import logger from './logger';
var link = ''
// link = "https://sisvend-api.smartmach.com.br"
link = "https://sisvend-backend.flowcap.net"
if (process.env.NODE_ENV === 'development') {
  link = "https://sisvend-backend.flowcap.net"
}
if (process.env.NODE_ENV === 'production') {
  link = "https://sisvend-api.smartmach.com.br"
}

const api = {

  url: link,

  findToken() {
    this.token = localStorage.getItem("auth_token");
  },

  newHeaders() {
    if (this.token) {
      return new Headers({
        "Content-Type": "application/json",
        Authorization: "Token " + this.token
      });
    } else {
      return new Headers({
        "Content-Type": "application/json"
      });
    }
  },
  newHeadersForm() {
    if (this.token) {
      return new Headers({
        Authorization: "Token " + this.token
      });
    } else {
      return new Headers({});
    }
  },

  async get(path) {
    const [method, mode, headers] = ["GET", "cors", this.newHeaders()];

    try {
      const res = await fetch(this.url + path, { method, mode, headers });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      const data = await clone.json();
      logger.success(method, res.status, path, data);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      return err;
    }
  },

  async post(path, body_) {
    const [method, mode, headers, body] = [
      "POST",
      "cors",
      this.newHeaders(),
      JSON.stringify(body_)
    ];

    try {
      const res = await fetch(this.url + path, { method, mode, headers, body });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      const data = await clone.json();
      logger.success(method, res.status, path, data);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      return err;
    }
  },

  async postMore(path, body_) {
    const [method, mode, headers, body] = [
      "POST",
      "cors",
      this.newHeaders(),
      JSON.stringify(body_)
    ];

    try {
      const res = await fetch(this.url + path, { method, mode, headers, body });
      if (res.status !== 200 ) throw res;
      // logger.success(method, res.status, path, data);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      return err;
    }
  },

  async put(path, body_) {
    const [method, mode, headers, body] = [
      "PUT",
      "cors",
      this.newHeaders(),
      JSON.stringify(body_)
    ];

    try {
      const res = await fetch(this.url + path, { method, mode, headers, body });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      const data = await clone.json();
      logger.success(method, res.status, path, data);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      throw err;
    }
  },

  async patch(path, body_) {
    const [method, mode, headers, body] = [
      "PATCH",
      "cors",
      this.newHeaders(),
      JSON.stringify(body_)
    ];

    try {
      const res = await fetch(this.url + path, { method, mode, headers, body });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      const data = await clone.json();
      logger.success(method, res.status, path, data);
      console.log('api', res)
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      throw err;
    }
  },


  async options(path, body_) {
    const [method, mode, headers, body] = ['OPTIONS', 'cors', this.newHeaders(), JSON.stringify(body_)];

    try {
      const res = await fetch(this.url + path, { method, mode, headers, body });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      const data = await clone.json();
      logger.success(method, res.status, path, data);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      throw err;
    }

  },

  async delete(path) {
    const [method, mode, headers] = ["DELETE", "cors", this.newHeaders()];

    try {
      const res = await fetch(this.url + path, { method, mode, headers });
      if (res.status < 200 || res.status >= 300) throw res;
      const clone = res.clone();
      logger.success(method, res.status, path, clone.statusText);
      return res;
    } catch (err) {
      logger.failure(method, err.status, path, err.statusText);
      return err;
    }
  },

  postForm(path, body) {
    return fetch(this.url + path, {
      method: "POST",
      mode: "cors",
      headers: this.newHeadersForm(),
      body: body
    });
  },

  getForm(path) {
    return fetch(this.url + path, {
      method: 'GET',
      mode: 'cors',
      headers: this.newHeadersForm()
    });
  },

  putForm(path, body) {
    return fetch(this.url + path, {
      method: "PUT",
      mode: "cors",
      headers: this.newHeadersForm(),
      body: body
    });
  }
};

export default api;